import axios from "axios";
import { appConfig, AppConfigEnvKey } from "../config/app.config";

export default axios.create({
    baseURL: appConfig.get(AppConfigEnvKey.REACT_APP_BASE_URL),
    timeout: 100000,
    headers: {
        "Content-Type": "application/json",
    },
});
